import mutate, { addToCache, removeFromCache } from '@/utils/mutateWrapper'
import {
  PAYMENT_METHODS_QUERY,
  DEFAULT_PAYMENT_METHOD_QUERY,
  ADD_PAYMENT_METHOD_MUTATION,
  DELETE_PAYMENT_METHOD_MUTATION
} from '../gql/payment.gql'

export const addPaymentMethod = data => {
  const update = addToCache(PAYMENT_METHODS_QUERY, 'paymentMethods')
  return mutate(ADD_PAYMENT_METHOD_MUTATION, { data }, { update })
}

export const deletePaymentMethod = id => {
  return mutate(
    DELETE_PAYMENT_METHOD_MUTATION,
    { id },
    {
      refetchQueries: [
        { query: PAYMENT_METHODS_QUERY },
        { query: DEFAULT_PAYMENT_METHOD_QUERY }
      ],
      awaitRefetchQueries: true
    }
  )
}
